import React, { useState } from 'react';
import { Card, CardBody, Button, Input, FormGroup, Label } from 'reactstrap';

const ManualTokenRenewal = ({ countryId, onSuccess }) => {
  const [shortToken, setShortToken] = useState('');
  const [isRenewing, setIsRenewing] = useState(false);

  const handleManualRenewal = async () => {
    if (!shortToken.trim()) {
      alert('Inserisci il token temporaneo');
      return;
    }

    setIsRenewing(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_FUNCTIONS_URL}/ws/facebook/renew-token`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            countryId,
            shortLivedToken: shortToken,
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        alert(
          `Token rinnovato con successo! Scade tra ${result.daysUntilExpiration} giorni.`,
        );
        setShortToken('');
        onSuccess();
      } else {
        alert(`Errore: ${result.error}`);
      }
    } catch (error) {
      console.error('Errore nel rinnovo manuale:', error);
      alert('Errore nel rinnovo del token');
    } finally {
      setIsRenewing(false);
    }
  };

  return (
    <Card>
      <CardBody>
        <h5 className="mb-3">🔧 Rinnovo Manuale</h5>

        <div className="mb-3">
          <p className="text-muted mb-2">
            <strong>1.</strong> Vai su{' '}
            <a
              href="https://developers.facebook.com/tools/explorer/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary">
              Facebook Graph API Explorer
              <i className="bx bx-link-external ml-1"></i>
            </a>
          </p>
          <p className="text-muted mb-2">
            <strong>2.</strong> Seleziona la tua app e genera un token
          </p>
          <p className="text-muted mb-3">
            <strong>3.</strong> Incolla il token qui sotto:
          </p>
        </div>

        <FormGroup>
          <Label for="tokenInput">Token Temporaneo</Label>
          <Input
            type="text"
            id="tokenInput"
            value={shortToken}
            onChange={(e) => setShortToken(e.target.value)}
            placeholder="Incolla il token temporaneo di Facebook"
            style={{
              fontFamily: 'Monaco, Menlo, Consolas, monospace',
              fontSize: '12px',
            }}
          />
        </FormGroup>

        <Button
          color="primary"
          onClick={handleManualRenewal}
          disabled={isRenewing || !shortToken.trim()}
          block>
          {isRenewing ? (
            <>
              <i className="bx bx-loader bx-spin mr-2"></i>
              Rinnovando...
            </>
          ) : (
            <>
              <i className="bx bx-check mr-2"></i>
              Rinnova Token
            </>
          )}
        </Button>

        <div className="mt-3">
          <small className="text-muted">
            <i className="bx bx-info-circle mr-1"></i>
            Il token inserito sarà automaticamente convertito in un long-lived
            token valido per 60 giorni.
          </small>
        </div>
      </CardBody>
    </Card>
  );
};

export default ManualTokenRenewal;
